<template>
  <div class="content-information">
    <div v-if="$slots['fragment']">
      <slot name="fragment" />
    </div>
    <div class="content-information__main">
      <div
        v-if="category || shortDate || author"
        class="content-information__category-date-author"
      >
        <zg-label
          v-if="category"
          :text="category"
          size="small"
        />
        <div class="content-information__date-author">
          <span v-if="shortDate">{{ shortDate }}</span>
          <span v-if="shortDate && author">,&nbsp;</span>
          <span v-if="author">{{ `${author}` }}</span>
        </div>
      </div>
      <slot name="content" />
    </div>
    <aside>
      <slot name="aside" />
    </aside>
  </div>
</template>

<script>
  import { ZgLabel } from '../ZgLabel'

  export default {
    name: 'ZgContentInformation',
    components: { ZgLabel },
    props: {
      name: {
        type: String,
        required: false,
        default: ''
      },
      description: {
        type: String,
        required: false,
        default: ''
      },
      orgNoLabel: {
        type: String,
        required: false,
        default: ''
      },
      orgNo: {
        type: String,
        required: false,
        default: null
      },
      city: {
        type: String,
        required: false,
        default: null
      },
      address: {
        type: String,
        required: false,
        default: null
      },
      phoneNo: {
        type: String,
        required: false,
        default: null
      },
      logo: {
        type: Object,
        required: false,
        default: null,
        validator: item => {
          return item.src
        }
      },
      category: {
        type: String,
        required: false,
        default: null
      },
      author: {
        type: String,
        required: false,
        default: null
      },
      shortDate: {
        type: String,
        required: false,
        default: null
      }
    }
  }
</script>

<style lang="scss" scoped>
.content-information {
  display: flex;
  flex-direction: column;
  gap: rhythm(medium);

  @include mq(large) {
    display: grid;
  }

  &__main {
    @include mq(large) {
      grid-row: 1 / 4;
    }
  }

  &__category-date-author {
    display: inline-flex;
    flex-wrap: wrap;
    gap: rhythm(xsmall);
    margin-bottom: rhythm(base);
  }

  &__date-author {
    @include type-body-s;

    display: inline-flex;
    color: color(gray-500);
    margin-bottom: 0;
  }

  ::v-deep ul,
  ::v-deep ol {
    padding-left: rhythm(large);
  }

  @include mq(large) {
    grid-template-columns: 2fr 1fr;
    gap: rhythm(double);
  }
}

::v-deep .zg-label {
  margin-bottom: 0;
}

aside {
  @include mq(large) {
    width: 100%;
    align-self: flex-start;
  }
}
</style>
